import styles from "../styles/LocalProjectAddonBanner.module.scss";

export const LocalProjectInfoUK = () => (
  <div className={styles.moreInfoCopy}>
    <p>
      {`Increase your impact by planting extra trees right here in the United
      Kingdom. Your contribution will help to fund `}
      <a
        href="https://ecologi.com/projects/reforestation-projects-in-the-uk"
        target="_blank"
        rel="noopener noreferrer"
        className="link"
        title="View our UK projects! (new tab)"
      >
        our tree planting projects around the UK
      </a>
      !
    </p>
    <ul>
      <li>Plant trees across the UK</li>
      <li>Protect iconic wildlife</li>
      <li>Updates and news from the project</li>
    </ul>
  </div>
);
